export function getArtikelDetailId(artikelGruppeNr: number, artikelNr: string): string {
    return artikelGruppeNr.toString() + '|' + artikelNr;
}

export function splitArtikelDetailId(recordNr?: string): { artikelGruppeNr: number; artikelNr: string } | null {
    if (recordNr) {
        const [artikelGruppeNrS, artikelNr] = recordNr.split('|');
        if (artikelGruppeNrS && artikelNr) {
            return {
                artikelGruppeNr: parseInt(artikelGruppeNrS, 10),
                artikelNr,
            };
        }
    }
    return null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function logDifference(label: string, a: any, b: any) {
    Object.keys(a).forEach((k) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((a as any)[k] !== (b as any)?.[k]) {
            console.info(
                label + ' - different: ',
                k,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (a as any)[k],
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (b as any)?.[k],
            );
        }
    });
}

interface InstanceConfig {
    instance: string;
    navBackgroundColor: string;
}

export function getInstanceConfig(): InstanceConfig {
    if (window.location.host === 'salesmaster.easyloopsystem.at') {
        return {
            instance: 'easyloop',
            navBackgroundColor: '#121212',
        };
    }

    return {
        instance: 'bdspack',
        navBackgroundColor: '#508e6a',
    };
}
